import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { Sparkles } from 'lucide-react';
const AIBriefings = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-1490">
      <div className="w-20 flex-shrink-0" data-id="element-1491">
        <Sidebar data-id="element-1492" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1493">
        <Topbar data-id="element-1494" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-1495">
          <PageHeader title="AI Briefings" subtitle="Insights e raccomandazioni generate dall'intelligenza artificiale" data-id="element-1496" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-1497">
            <div className="text-center" data-id="element-1498">
              <Sparkles className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-1499" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-1500">
                AI Briefings
              </h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-1501">
                Questa pagina conterrà briefing e insights generati dall'AI.
                Coming soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default AIBriefings;